import { sharedWrapPageElement } from "./gatsby-shared";

export const wrapPageElement = sharedWrapPageElement;
